import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbSecurityModule } from '@nebular/security';
import {
  NbAccordionModule,
  NbActionsModule,
  NbAutocompleteModule,
  NbButtonModule,
  NbCardModule,
  NbContextMenuModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbMenuModule,
  NbPopoverModule,
  NbSearchModule,
  NbSelectModule,
  NbSidebarModule,
  NbTabsetModule,
  NbThemeModule,
  NbTooltipModule,
  NbUserModule,
} from '@nebular/theme';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RequestForApprovalsModule } from '../pages/home/intranet/request-for-approvals/request-for-approvals.module';
import { RequestForApprovalsV2Module } from '../pages/home/intranet/request-for-approvals-v2/request-for-approvals-v2.module';
import { PipesModule } from '../shared/pipes/pipes.module';
import {
  FooterComponent,
  HeaderComponent,
  SearchInputComponent,
} from './components';
import { ProfileComponent } from './components/header/profile/profile.component';
import {
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
} from './layouts';
import {
  CapitalizePipe,
  NumberWithCommasPipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
} from './pipes';
import { CORPORATE_THEME } from './styles/theme.corporate';
import { COSMIC_THEME } from './styles/theme.cosmic';
import { DARK_THEME } from './styles/theme.dark';
import { DEFAULT_THEME } from './styles/theme.default';
import { PeopleDetailsComponent } from './components/header/people-details/people-details.component';
import { RemindersModule } from '../pages/home/dynamic-stack/reminders/reminders.module';
import { RemindersV2Module } from '../pages/home/dynamic-stack/reminders-v2/reminders-v2.module';
import { ForexModule } from '../pages/home/dynamic-stack/forex/forex.module';

const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbCardModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbEvaIconsModule,
  NbInputModule,
  NbFormFieldModule,
  NbPopoverModule,
  RouterModule,
  ReactiveFormsModule,
  NbButtonModule,
  FlexLayoutModule,
  FormsModule,
  NbAutocompleteModule,
  RequestForApprovalsModule,
  RequestForApprovalsV2Module,
  PipesModule,
  NbAccordionModule,
  NbTooltipModule,
  NbTabsetModule,
  FontAwesomeModule
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  SearchInputComponent,
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
];
const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
];

@NgModule({
  imports: [RemindersModule,RemindersV2Module,ForexModule,CommonModule, ...NB_MODULES],
  exports: [CommonModule, ...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...PIPES, ProfileComponent, PeopleDetailsComponent],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: 'default',
          },
          [DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME, DARK_THEME],
        ).providers,
      ],
    };
  }
}
